const searchToggle = document.querySelector('.js-toggle-search');
const searchBar = document.querySelector('.js-search-bar');
const searchInput = searchBar?.querySelector('.js-search-bar-input');
const searchClose = document.querySelector('.js-close-search');

searchToggle?.addEventListener('click', () => {
  searchBar?.removeAttribute('aria-hidden');
  setTimeout(() => searchInput?.focus(), 50);
});

searchClose?.addEventListener('click', () => {
  searchBar?.setAttribute('aria-hidden', '');
});
